<button
  (click)="scrollToTop()"
  [class.hidden]="isHidden$ | async"
  [class.floating-panel-visible]="isFloatingPanelVisible$ | async"
  class="scroll-to-top"
>
  <sd-icon [type]="iconArrowTop"></sd-icon>
</button>
